import featureFlagsService from 'services/featureFlags'

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS'

export const setFeatureFlags = (flags) => ({
  type: SET_FEATURE_FLAGS,
  flags,
})

export const loadFeatureFlags = () => async (dispatch) => {
  try {
    const response = await featureFlagsService.fetchFeatureFlags()
    dispatch(setFeatureFlags(response?.data?.data || {}))
  } catch {
    // fallback seguro: flags ficam como false
  }
}
